import { render } from "./Postponements.vue?vue&type=template&id=85df884a&ts=true"
import script from "./Postponements.vue?vue&type=script&lang=ts"
export * from "./Postponements.vue?vue&type=script&lang=ts"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__